export const PRODUCT_HANDLE_STORAGE_KEY = "gwRegistryProductHandle";

export enum REGISTRY_FORM_MODAL_ACTION_TYPES {
    create = "create",
    update = "update",
}

export enum SELECT_REGISTRY_ACTION_TYPES {
    create = "create",
    delete = "delete",
}
